import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {AuthenticationService} from '../../../authentication/services/authentication.service';

export const MultiRoleGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);
  const allowedRoles = route.data?.['allowedRoles'] as string[] || [];
  if (allowedRoles.includes(authenticationService.typeLogin ?? '')) {
    return true;
  }

  return router.createUrlTree(['/login']);
};
